import { formatMoney } from '@belong/common';
import { Text } from '@belong/ui';
import type { TextProps } from '@belong/ui';
import clsx from 'clsx';

type RentAmountProps = {
  rentAmount: number;
  priceVariant?: TextProps['variant'];
  className?: string;
};

export function RentAmount({
  rentAmount,
  priceVariant = 'body',
  className,
}: RentAmountProps) {
  return (
    <div className={clsx('inline-flex shrink-0 items-baseline', className)}>
      <Text as="span" variant={priceVariant} fontWeight="semibold">
        {formatMoney(rentAmount)}
      </Text>
      <Text as="span" fontWeight="semibold" className="ml-2xs">
        /mo.
      </Text>
    </div>
  );
}
